/**
 * Shared utility helpers for the Argus Table library.
 *
 * resolveField  – dot-notation path resolution on row objects
 * escapeHtml    – basic HTML entity escaping for safe text rendering
 */

/**
 * Resolve a dot-notation field path against a row object.
 *
 * @param {Object} row   - The data row to read from
 * @param {string} field - Dot-delimited path (e.g. "device.manufacturer.name")
 * @returns {*} The resolved value, or undefined if any segment is null/undefined
 */
export function resolveField(row, field) {
  if (row == null || typeof field !== 'string' || field === '') {
    return undefined
  }

  const keys = field.split('.')

  return keys.reduce((obj, key) => {
    if (obj == null) {
      return undefined
    }
    return obj[key]
  }, row)
}

/**
 * HTML-entity map used by escapeHtml.
 * @type {Object<string, string>}
 */
const HTML_ESCAPE_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

/**
 * Escape special HTML characters in a string so it can be safely
 * inserted into the DOM via innerHTML without XSS risk.
 *
 * Non-string inputs are coerced to string first; null/undefined
 * return an empty string.
 *
 * @param {*} str - The value to escape
 * @returns {string} The escaped string
 */
export function escapeHtml(str) {
  if (str == null) {
    return ''
  }

  const text = String(str)

  return text.replace(/[&<>"']/g, (char) => HTML_ESCAPE_MAP[char])
}
